import { Link, NavLink, Outlet } from "react-router-dom";
import { useWatchList } from "./lib/useWatchList";

export default function App() {
  const watch = useWatchList();
  const total = watch.riders.length + watch.events.length;
  return (
    <div className="min-h-screen flex flex-col text-base">
      <header className="border-b border-pit-border pit-panel sticky top-0 z-10 backdrop-blur supports-[backdrop-filter]:bg-pit-panel/80">
        <div className="max-w-5xl mx-auto px-4 py-3 flex items-center justify-between">
          <Link
            to="/"
            className="flex items-center gap-2 font-mono text-base sm:text-lg font-bold tracking-tight"
          >
            <span className="text-pit-accent text-lg">●</span>
            <span>RaceDay</span>
            <span className="text-pit-muted text-[10px] uppercase tracking-widest hidden sm:inline">
              permalink
            </span>
          </Link>
          <nav className="flex gap-1 text-sm font-mono">
            <NavTab to="/events">events</NavTab>
            <NavTab to="/watch">{`★ watch${total ? ` (${total})` : ""}`}</NavTab>
          </nav>
        </div>
      </header>
      <main className="flex-1 max-w-5xl mx-auto w-full px-4 py-5">
        <Outlet />
      </main>
      <footer className="border-t border-pit-border pit-panel py-3 text-center text-[11px] text-pit-muted font-mono">
        Pulls from results.racedayeventsoftware.com
      </footer>
    </div>
  );
}

function NavTab({ to, children }: { to: string; children: React.ReactNode }) {
  return (
    <NavLink
      to={to}
      className={({ isActive }) =>
        `px-3 py-1.5 rounded-md transition-colors ${
          isActive
            ? "bg-pit-border text-pit-text"
            : "text-pit-muted hover:text-pit-text"
        }`
      }
    >
      {children}
    </NavLink>
  );
}
